import React, { memo } from "react";
import { Typography, Tag } from "antd";
import Utils from "utils";
import { APPROVAL_OPTION } from "constants/index";
const { Title } = Typography;

const SlipTag = ({
  options = APPROVAL_OPTION,
  data,
  keyCode = "code",
  keyName = "createdByName",
  keyStatus = "signStatus",
  keyCreatedAt = "createdAt",
}) => {
  return (
    <>
      <div style={{ position: "absolute", top: 10, right: 0 }}>
        {(() => {
           
          const option = options.find(
            (opt) =>
              opt.id === data?.[keyStatus] || opt.value === data?.[keyStatus]
          );
          return option ? <Tag color={option.color}>{option.name}</Tag> : null;
        })()}
      </div>
      <Title level={2} className="mb-0">
        {data?.[keyCode]}
      </Title>
      <div style={{ fontSize: "12px" }}>
        <span style={{ color: "green" }}>{data?.[keyName]}</span> tạo lúc{" "}
        {keyCreatedAt && Utils.formatDate(data?.[keyCreatedAt])}
      </div>
    </>
  );
};

export default memo(SlipTag);
